import React from 'react';
import { Link } from 'react-router-dom';

const NotFound = () => (
  <div style={{ textAlign: 'center', marginTop: '50px' }}>
    <h1>404 - Page Not Found</h1>
    <p>Oops! The page you're looking for does not exist.</p>
    <Link to="/">Go Back to Home</Link>
  </div>
);

export default NotFound;